/**
 * SEO Data for all pages
 * Centralized SEO meta tags, titles, and descriptions
 */

export interface PageSEO {
    title: string;
    description: string;
    keywords?: string;
    canonical?: string;
}

export const seoData: Record<string, PageSEO> = {
    // Home
    home: {
        title: 'Oficina Automóvel na Malveira | Roady Centro-Auto Malveira',
        description: 'Oficina Roady na Malveira: revisões, pneus, mudança de óleo, travões e diagnóstico. Fale connosco ou peça orçamento sem compromisso.',
        keywords: 'oficina malveira, pneus malveira, revisão automóvel malveira, mecânica malveira, roady malveira',
        canonical: 'https://roadymalveira.pt/'
    },
    pneus: {
        title: 'Pneus na Malveira | Roady Centro-Auto Malveira',
        description: 'Pneus para o seu carro na Malveira. Aconselhamento na escolha, montagem e equilibragem por técnicos Roady. Peça orçamento sem compromisso.',
        keywords: 'pneus malveira, comprar pneus malveira, montagem pneus',
        canonical: 'https://roadymalveira.pt/loja/pneus'
    },

    // Workshop (Services Overview)
    workshop: {
        title: 'Serviços de Oficina na Malveira | Roady Centro-Auto Malveira',
        description: 'Revisão, pneus, óleo, travões, alinhamento e diagnóstico na Malveira. Veja todos os serviços do Roady Malveira e peça orçamento sem compromisso.',
        keywords: 'serviços automóvel malveira, oficina malveira, mecânica malveira',
        canonical: 'https://roadymalveira.pt/oficina'
    },

    // Service Details
    'revisoes-roady': {
        title: 'Revisão Automóvel na Malveira | Roady Centro-Auto Malveira',
        description: 'Revisão completa na Malveira, sem perder a garantia do seu carro. Veja o que está incluído e peça orçamento sem compromisso.',
        keywords: 'revisão automóvel malveira, revisão carro malveira, manutenção automóvel',
        canonical: 'https://roadymalveira.pt/oficina/revisoes-roady'
    },
    'alinhamento': {
        title: 'Alinhamento de Direção no Malveira — Roady Centro-Auto Malveira',
        description: 'Alinhamento profissional na Malveira. Menos desgaste nos pneus, condução segura e precisa. Peça orçamento sem compromisso.',
        keywords: 'alinhamento malveira, alinhamento direção malveira, geometria malveira',
        canonical: 'https://roadymalveira.pt/oficina/alinhamento'
    },
    'teste-diagnostico': {
        title: 'Diagnóstico Eletrónico no Malveira — Roady Centro-Auto Malveira',
        description: 'Diagnóstico eletrónico completo para todas as marcas. Identificação rápida e precisa de avarias. Roady Centro-Auto Malveira.',
        keywords: 'diagnóstico automóvel malveira, teste eletrónico malveira, diagnóstico carro',
        canonical: 'https://roadymalveira.pt/oficina/teste-diagnostico'
    },
    'travoes': {
        title: 'Serviço de Travões no Malveira — Roady Centro-Auto Malveira',
        description: 'Substituição de pastilhas e discos de travão no Malveira. Segurança garantida com profissionais Roady.',
        keywords: 'travões malveira, pastilhas travão malveira, discos travão malveira',
        canonical: 'https://roadymalveira.pt/oficina/travoes'
    },
    'amortecedores': {
        title: 'Amortecedores no Malveira — Roady Centro-Auto Malveira | Troca e Revisão',
        description: 'Troca e revisão de amortecedores no Malveira. Estabilidade e segurança com serviço Roady certificado.',
        keywords: 'amortecedores malveira, suspensão malveira, troca amortecedores',
        canonical: 'https://roadymalveira.pt/oficina/amortecedores'
    },
    'inspecao': {
        title: 'Pré-Inspeção Automóvel no Malveira — Roady Centro-Auto Malveira',
        description: 'Prepare o seu carro para a inspeção com o serviço Roady no Malveira. Verificação completa e rápida.',
        keywords: 'pré-inspeção malveira, inspeção automóvel malveira, preparação inspeção',
        canonical: 'https://roadymalveira.pt/oficina/inspecao'
    },
    'mecanica-geral': {
        title: 'Mecânica Automóvel no Malveira — Roady Centro-Auto Malveira',
        description: 'Mecânica automóvel completa no Malveira. Reparações e manutenção com técnicos especializados Roady.',
        keywords: 'mecânica geral malveira, reparação automóvel malveira, mecânico malveira',
        canonical: 'https://roadymalveira.pt/oficina/mecanica-geral'
    },
    'ar-condicionado': {
        title: 'Carregamento de Ar Condicionado Auto na Malveira | Roady',
        description: 'Carregamento e manutenção do ar condicionado do seu carro na Malveira. Saiba quando é preciso e peça orçamento sem compromisso.',
        keywords: 'ar condicionado auto malveira, carga AC malveira, reparação AC automóvel',
        canonical: 'https://roadymalveira.pt/oficina/ar-condicionado'
    },
    'baterias': {
        title: 'Baterias Automóvel no Malveira — Roady Centro-Auto Malveira',
        description: 'Teste e substituição de baterias automóvel no Malveira. Instalação com garantia Roady.',
        keywords: 'baterias auto malveira, bateria carro malveira, substituição bateria',
        canonical: 'https://roadymalveira.pt/oficina/baterias'
    },
    'restauro-farois': {
        title: 'Restauro de Faróis no Malveira — Roady Centro-Auto Malveira',
        description: 'Restauro profissional de faróis automóvel. Melhore a visibilidade e segurança. Roady Malveira.',
        keywords: 'restauro faróis malveira, polimento faróis malveira, recuperação faróis',
        canonical: 'https://roadymalveira.pt/oficina/restauro-farois'
    },
    'servicos-oficina': {
        title: 'Plano de Serviços Oficina — Roady Centro-Auto Malveira',
        description: 'Planos de serviços e manutenção para a sua oficina. Soluções completas Roady no Malveira.',
        keywords: 'plano serviços malveira, manutenção oficina malveira',
        canonical: 'https://roadymalveira.pt/oficina/servicos-oficina'
    },

    // Store & Categories
    store: {
        title: 'Loja Auto no Malveira — Roady Centro-Auto Malveira | Peças e Acessórios',
        description: 'Óleos, acessórios, produtos auto, limpeza e manutenção. Loja Roady Malveira.',
        keywords: 'loja auto malveira, peças automóvel malveira, acessórios auto malveira',
        canonical: 'https://roadymalveira.pt/loja'
    },
    'loja-eletricidade': {
        title: 'Eletricidade Automóvel — Loja Roady Malveira',
        description: 'Componentes elétricos, baterias e acessórios elétricos para automóvel. Roady Malveira.',
        keywords: 'eletricidade auto malveira, componentes elétricos carro',
        canonical: 'https://roadymalveira.pt/loja/eletricidade'
    },
    'loja-equipamento-interior': {
        title: 'Equipamento Interior Auto — Loja Roady Malveira',
        description: 'Acessórios e equipamentos para interior do automóvel. Qualidade garantida Roady.',
        keywords: 'equipamento interior auto, acessórios interior carro malveira',
        canonical: 'https://roadymalveira.pt/loja/equipamento-interior'
    },
    'loja-equipamento-exterior': {
        title: 'Equipamento Exterior Auto — Loja Roady Malveira',
        description: 'Acessórios e equipamentos para exterior do automóvel. Loja Roady Malveira.',
        keywords: 'equipamento exterior auto, acessórios exterior carro malveira',
        canonical: 'https://roadymalveira.pt/loja/equipamento-exterior'
    },
    'loja-lubrificantes': {
        title: 'Lubrificantes e Óleos Auto — Loja Roady Malveira',
        description: 'Óleos motor, lubrificantes e produtos de manutenção. Marcas de confiança no Roady Malveira.',
        keywords: 'óleo motor malveira, lubrificantes auto malveira',
        canonical: 'https://roadymalveira.pt/loja/lubrificantes'
    },
    'loja-manutencao': {
        title: 'Produtos de Manutenção Auto — Loja Roady Malveira',
        description: 'Produtos de manutenção e cuidado automóvel. Roady Malveira.',
        keywords: 'produtos manutenção auto, cuidado automóvel malveira',
        canonical: 'https://roadymalveira.pt/loja/manutencao'
    },
    'loja-pecas-tecnicas': {
        title: 'Peças Técnicas Auto — Loja Roady Malveira',
        description: 'Peças técnicas e componentes para automóvel. Qualidade garantida Roady.',
        keywords: 'peças técnicas auto malveira, componentes carro',
        canonical: 'https://roadymalveira.pt/loja/pecas-tecnicas'
    },
    'loja-pneus': {
        title: 'Pneus na Malveira | Roady Centro-Auto Malveira',
        description: 'Pneus para o seu carro na Malveira. Aconselhamento na escolha, montagem e equilibragem por técnicos Roady. Peça orçamento sem compromisso.',
        keywords: 'pneus malveira, comprar pneus malveira, montagem pneus',
        canonical: 'https://roadymalveira.pt/loja/pneus'
    },
    'loja-som-multimedia-navegacao': {
        title: 'Som, Multimédia e Navegação — Loja Roady Malveira',
        description: 'Sistemas de som, multimédia e navegação GPS para automóvel. Roady Malveira.',
        keywords: 'som auto malveira, GPS carro malveira, multimédia automóvel',
        canonical: 'https://roadymalveira.pt/loja/som-multimedia-navegacao'
    },
    'loja-ferramentas': {
        title: 'Ferramentas Auto — Loja Roady Malveira',
        description: 'Ferramentas profissionais e acessórios para manutenção automóvel. Roady Malveira.',
        keywords: 'ferramentas auto malveira, ferramentas mecânica',
        canonical: 'https://roadymalveira.pt/loja/ferramentas'
    },

    // Other Pages
    budget: {
        title: 'Peça Orçamento Automóvel na Malveira | Roady Malveira',
        description: 'Peça orçamento para revisão, pneus, travões ou mudança de óleo no Roady Malveira. Diga-nos o que o carro precisa e respondemos com um valor claro.',
        keywords: 'orçamento auto malveira, pedir orçamento oficina malveira',
        canonical: 'https://roadymalveira.pt/orcamento'
    },
    mobility: {
        title: 'Mobilidade Urbana Malveira — Roady Centro-Auto Malveira',
        description: 'Bicicletas e trotinetes elétricas no Malveira. Assistência e apoio Roady.',
        keywords: 'mobilidade malveira, bicicletas elétricas malveira, trotinetes malveira',
        canonical: 'https://roadymalveira.pt/mobilidade'
    },
    recruitment: {
        title: 'Recrutamento — Roady Centro-Auto Malveira',
        description: 'Junte-se à equipa Roady Centro-Auto Malveira. Procuramos talento para o setor automóvel. Envie candidatura.',
        keywords: 'emprego malveira, trabalho oficina malveira, recrutamento roady',
        canonical: 'https://roadymalveira.pt/recrutamento'
    },
    contact: {
        title: 'Contactos e Horário | Roady Centro-Auto Malveira',
        description: 'Morada, horário, telefone e WhatsApp do Roady Centro-Auto Malveira. Fale connosco ou peça orçamento sem compromisso.',
        keywords: 'contacto roady malveira, telefone oficina malveira, morada roady',
        canonical: 'https://roadymalveira.pt/contacto'
    },
    wecall: {
        title: 'Ligamos-lhe — Roady Centro-Auto Malveira',
        description: 'Deixe os seus dados e ligamos-lhe. Atendimento personalizado Roady Malveira.',
        keywords: 'contacto roady malveira, ligação gratuita',
        canonical: 'https://roadymalveira.pt/ligamos'
    },
    wishlist: {
        title: 'Lista de Desejos — Roady Centro-Auto Malveira',
        description: 'Guarde os seus produtos favoritos na lista de desejos. Loja Roady Malveira.',
        canonical: 'https://roadymalveira.pt/lista-desejos'
    },

    // Legal Pages
    cookies: {
        title: 'Política de Cookies — Roady Centro-Auto Malveira',
        description: 'Política de cookies do website Roady Centro-Auto Malveira. Saiba como utilizamos cookies.',
        canonical: 'https://roadymalveira.pt/politica-cookies'
    },
    privacy: {
        title: 'Política de Privacidade — Roady Centro-Auto Malveira',
        description: 'Política de privacidade e proteção de dados do Roady Centro-Auto Malveira.',
        canonical: 'https://roadymalveira.pt/politica-privacidade'
    },
    terms: {
        title: 'Termos e Condições — Roady Centro-Auto Malveira',
        description: 'Termos e condições de utilização do website Roady Centro-Auto Malveira.',
        canonical: 'https://roadymalveira.pt/termos-condicoes'
    }
};

/**
 * Get SEO data for a service page
 */
export const getServiceSEO = (serviceSlug: string): PageSEO => {
    return seoData[serviceSlug] || seoData.workshop;
};

/**
 * Get SEO data for a store category page
 */
export const getStoreCategorySEO = (categorySlug: string): PageSEO => {
    const key = `loja-${categorySlug}`;
    return seoData[key] || seoData.store;
};

